import { z } from 'zod'
import { chatbotModels, chatbotProviders, getChatbotModel } from '@forgd/shared/chatbot'

export const chatbotPlaygroundSettingsSchema = z
  .object({
    systemPrompt: z.string().max(100_000),
    modelId: z
      .string()
      .refine((modelId) => chatbotModels.some((model) => model.id === modelId), 'Invalid chatbot model'),
    provider: z.enum(chatbotProviders),
    temperature: z.number().min(0).max(2),
    maxOutputTokens: z.number().int().min(1),
  })
  .superRefine((value, ctx) => {
    const model = getChatbotModel(value.modelId)

    if (value.maxOutputTokens > model.maxOutputTokens) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['maxOutputTokens'],
        message: `Max output tokens cannot exceed ${model.maxOutputTokens} for ${model.label}.`,
      })
    }
  })
